import React from 'react'
import { useRecoilState } from 'recoil'
import {
  InGameAccountModalState,
  selectCategoryProfileState,
} from '../../../../../common/atoms/checkout'
import { CategoryResponse } from '../../../../../types/categories/responses/category-response'
import { CategoryProfileResponse } from '../../../../../types/users/category-profile-response'
import { InGameAccountModalStatusEnum } from '../../../../../common/enums/in-game-account-modal-status.enum'
import Image from 'next/image'
import Divider from '../../../../divider/Divider'
import ProfileEditingCard from './ProfileEditingCard'
import { useTranslation } from 'next-i18next'

type Props = {
  profiles?: CategoryProfileResponse[]
  game: CategoryResponse
  getProfile: any
}

export default function AccountsSection({ profiles, game, getProfile }: Props) {
  const [modalStatus, setModalStatus] = useRecoilState(InGameAccountModalState)
  const [, setChosenId] = useRecoilState(selectCategoryProfileState)
  const { t } = useTranslation('inGameModal')

  return (
    <div
      className={`mx-8 mt-4 ${
        modalStatus === InGameAccountModalStatusEnum.ACCOUNTS
          ? 'flex'
          : 'hidden'
      } flex-col`}
    >
      <div className={'mt-1 flex flex-row items-center justify-between'}>
        <div className={'flex flex-col'}>
          <h3 className={'text-body-semibold text-fizz-1000'}>{game?.name}</h3>

          <label className={'text-secondary-normal text-gray-100'}>
            {t('selectAccountDescription')}
          </label>
        </div>

        <div className={'relative h-14 w-20'}>
          <Image
            src={
              game?.landscapeImageAsset?.imageUrl ??
              game.imageAsset?.imageUrl ??
              process.env.NEXT_PUBLIC_DEFAULT_IMAGE_URL!
            }
            alt={game.name}
            className={'object-cover'}
            fill={true}
          />
        </div>
      </div>

      <div className={'mb-3 mt-4'}>
        <Divider backgroundColor={'border-gray-30'} />
      </div>

      {/* All editCards  */}
      <div className={'mt-2 flex flex-col gap-1'}>
        {profiles?.map((item) => {
          return (
            <ProfileEditingCard
              key={item.id}
              profile={item}
              getProfile={getProfile}
            />
          )
        })}
      </div>

      {/*should add limit of Account*/}
      <button
        onClick={() => {
          setChosenId(-1)
          setModalStatus(InGameAccountModalStatusEnum.ADD)
        }}
        className={'btn-v2-white mt-6'}
      >
        {t('addAccountBtnTitle')}
      </button>
    </div>
  )
}
